export default __webpack_public_path__ + "static/media/provesional_restoration_lower_48_4@2x.ebfe0bda.png";